__turbopack_context__.v({
  "cartContainer": "Recommendations-module-scss-module__GSpNJa__cartContainer",
  "container": "Recommendations-module-scss-module__GSpNJa__container",
  "fadeLeft": "Recommendations-module-scss-module__GSpNJa__fadeLeft",
  "fadeLeftHide": "Recommendations-module-scss-module__GSpNJa__fadeLeftHide",
  "fadeRight": "Recommendations-module-scss-module__GSpNJa__fadeRight",
  "fadeRightHide": "Recommendations-module-scss-module__GSpNJa__fadeRightHide",
  "header": "Recommendations-module-scss-module__GSpNJa__header",
  "homeContainer": "Recommendations-module-scss-module__GSpNJa__homeContainer",
  "homeHeader": "Recommendations-module-scss-module__GSpNJa__homeHeader",
  "plpSwiper": "Recommendations-module-scss-module__GSpNJa__plpSwiper",
  "screenReaderOnly": "Recommendations-module-scss-module__GSpNJa__screenReaderOnly",
  "swipeButtHide": "Recommendations-module-scss-module__GSpNJa__swipeButtHide",
  "swipeButtNext": "Recommendations-module-scss-module__GSpNJa__swipeButtNext",
  "swipeButtPrev": "Recommendations-module-scss-module__GSpNJa__swipeButtPrev",
  "swiper": "Recommendations-module-scss-module__GSpNJa__swiper",
  "swiperContainer": "Recommendations-module-scss-module__GSpNJa__swiperContainer",
  "swiperWrapper": "Recommendations-module-scss-module__GSpNJa__swiperWrapper",
  "swiperWrapperPlp": "Recommendations-module-scss-module__GSpNJa__swiperWrapperPlp",
  "thumbSlide": "Recommendations-module-scss-module__GSpNJa__thumbSlide",
});
